import { getUtcTime } from '@bingads-webui-universal/primitive-utilities';
import { constants } from '../constants';
import { Logger } from './logger';
import {
  IScenario, IActivity, TErrorLogArgs, IErrorLogger,
} from '../types';

/* eslint-disable max-len */

/**
 * Default Error Logger
 */
export class ErrorLogger extends Logger implements IErrorLogger {
  /**
   * error - logs passed in args as error logs
   */
  error(
    scenario: IScenario,
    activity: IActivity,
    parentScenario: IScenario,
    [
      message, api, requestId, impactUser, httpMethod, logLevel,
    ]: TErrorLogArgs,
  ): void {
    super.log({
      api,
      message,
      requestId,
      impactUser: impactUser || constants.IMPACTUSER.NA,
      httpMethod,
      timeStamp: getUtcTime(),
      logCategory: constants.LOGCATEGORY.ERROR,
      logLevel: logLevel || constants.LOGLEVEL.INFO,
      entryType: constants.ENTRYTYPE.MESSAGE,
      activity,
      scenario,
      parentScenario,
    });
  }

  getLogMethods() {
    return ['error'];
  }
}
